<h2 mat-dialog-title>{{ 'QUERY_EXECUTED_SQL_TITLE' | transloco }}</h2>

<mat-dialog-content>
  <pre class="sql-block">{{ sql }}</pre>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-icon-button [matTooltip]="(copied ? 'COPIED' : 'QUERY_EXECUTED_SQL_COPY') | transloco" (click)="copy()">
    <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
  </button>
  <button mat-stroked-button (click)="dialogRef.close()">
    {{ 'CLOSE' | transloco }}
  </button>
</mat-dialog-actions>
